import React, { useState } from "react";
import CaretDown from "../../assets/svg/icons/common/CaretDown";
import styles from "./styles.module.scss";

const Collapsible = ({
  title,
  children,
  defaultExpanded = false,
  className = "",
  headerClassName = "",
  headingUppercase = true,
  bodyClassName = "",
  wideLetterSpacing = false,
}) => {
  const [open, setOpen] = useState(defaultExpanded);

  return (
    <div className={`${styles.card} ${className}`}>
      <div
        className={`${styles.header} ${headerClassName}`}
        onClick={() => setOpen(!open)}
      >
        <CaretDown className={`${styles.caret} ${open ? styles.rotate : ""}`} />
        <h6
          className={`${styles.heading} ${headingUppercase ? styles.uppercase : ""} ${wideLetterSpacing ? styles.wideLetterSpacing : ""}`}
        >
          {title}
        </h6>
      </div>

      {open && (
        <div className={`${styles.body} ${bodyClassName}`}>{children}</div>
      )}
    </div>
  );
};

export default Collapsible;
